import { Location } from '@angular/common';
import { Component, DoCheck, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Platform } from '@ionic/angular';
import { AlertService, AuthenticationService } from '../../_services';
import { CloseOverlayService } from '../../_services/closeOverlay.service';
import { CashiersStore } from '../../_services/store/cashiersStore.service';

@Component({
  selector: 'app-add-cashier',
  templateUrl: './add-cashier.page.html',
  styleUrls: ['./add-cashier.page.scss'],
})
export class AddCashierPage implements OnInit, DoCheck {
  subscription: any;
  disabled = true;
  loading = true;
  nameExists = false;
  emailExists = false;
  phoneExists = false;
  cashiers = [];
  cashierForm: FormGroup;
  existingCashiers = this.cashiersStore.getExistingCashiers();

  constructor(
    private formBuilder: FormBuilder,
    private auth: AuthenticationService,
    private alertService: AlertService,
    private platform: Platform,
    private location: Location,
    private cashiersStore: CashiersStore,
    private closeOverlayService: CloseOverlayService
  ) {
    this.cashiers = this.cashiersStore.getCashiers();
  }

  public errorMessages = {
    name: [
      { type: 'required', message: 'Cashier\'s name is required' },
      // { type: 'maxlength', message: 'Cahier\'s Name cannot be more than 20 characters' }
    ],
    email: [
      { type: 'required', message: 'Email is required' },
      { type: 'pattern', message: 'Please enter a valid email address' },
    ],
    phone: [
      { type: 'required', message: 'Phone Number is required' },
      { type: 'minlength', message: 'Phone number must be 11 digits' },
      { type: 'maxlength', message: 'Phone number must be 11 digits' },
      { type: 'pattern', message: 'Please enter only digits' },
    ],
  };

  get name() {
    return this.cashierForm.get('name');
  }
  get email() {
    return this.cashierForm.get('email');
  }
  get phone() {
    return this.cashierForm.get('phone');
  }

  dismissModal() {
    this.alertService.dismissModal();
  }

  addCashier() {
    this.disabled = !this.disabled;
    this.loading = !this.loading;
    this.auth
      .addNewCashier(this.name.value, this.email.value, this.phone.value)
      .subscribe(
        (response) => {
          this.disabled = !this.disabled;
          this.loading = !this.loading;
          console.log(response);
          this.dismissModal();
          this.alertService.standardToastWithOptions(
            'New Cashier Created',
            'Your new Cashier <strong>"' +
              this.name.value +
              '"</strong> has been added. A mail has been sent to their email address'
          );
          this.cashiersStore.setIsCashierAdded(true);
        },
        (error) => {
          this.disabled = !this.disabled;
          this.loading = !this.loading;
          console.log(error);
          if (error.error.message.includes('Email must be valid')) {
            this.alertService.standardAlert(
              'Please provide a valid email address'
            );
          } else if (error.error.message.includes('email must be unique')) {
            this.alertService.standardAlert(
              'Email is taken. Please correct your email address and try again'
            );
          } else if (error.error.message.includes('phone must be unique')) {
            this.alertService.standardAlert(
              'Phone Number is taken. Please correct your phone number and try again'
            );
          } else {
            this.alertService.standardAlertNullDuration(error.error.message);
          }
        }
      );
  }

  getCashiers() {
    this.auth.getCashiers().subscribe((response: any) => {
      console.log(response);
      this.cashiersStore.setCashiers(response);
      this.cashiers = this.cashiersStore.getCashiers();
    });
  }

  ionViewDidEnter() {
    this.subscription = this.platform.backButton.subscribeWithPriority(
      99999,
      () => {
        if (this.constructor.name === 'AddCashierPage') {
          this.closeOverlayService.trigger();
        } else {
          this.location.back();
        }
      }
    );
  }

  ionViewDidLeave() {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    this.cashierForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern('^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$'),
        ],
      ],
      phone: [
        '',
        [
          Validators.required,
          Validators.minLength(11),
          Validators.maxLength(11),
          Validators.pattern('^[0-9]*$'),
        ],
      ],
    });
    window.addEventListener('keydown', (e) => {
      const pathname = window.location.pathname;
      if (
        e.key === 'Enter' &&
        this.disabled === false &&
        pathname.includes('cashiers')
      ) {
        this.addCashier();
      }
    });
  }

  ngDoCheck(): void {
    !this.cashierForm.valid ? (this.disabled = true) : (this.disabled = false);
    // if (this.existingCashiers.includes(this.name.value)) {
    //   this.disabled = true;
    //   this.nameExists = true;
    // } else {
    //   this.nameExists = false;
    // }
    // if (this.existingCashiers.includes(this.email.value)) {
    //   this.disabled = true;
    //   this.emailExists = true;
    // } else {
    //   this.emailExists = false;
    // }
    // if (this.existingCashiers.includes(this.phone.value)) {
    //   this.disabled = true;
    //   this.phoneExists = true;
    // } else {
    //   this.phoneExists = false;
    // }
  }
}
